import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";


// Get Table Data
export const PHTableDataAPI = createAsyncThunk("PHTableData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_WS_LocationID,
        M_UserID,
        Flag,
        token,
        From,
        To,
        DashProjectTypeId,
        RoleID,
        handleWaterSupplyPHExport
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url

    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_Distri_WaterQualityPH_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_Distri_WS_LocationID=${M_WS_LocationID ? M_WS_LocationID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    } else {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_WS_WaterQualityPH_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WS_LocationID=${M_WS_LocationID ? M_WS_LocationID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    }

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleWaterSupplyPHExport && handleWaterSupplyPHExport()
                return result.data
            } else {
                return result
            }
        })
})

const PHTableDataSlice = createSlice({
    name: "PHTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PHTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(PHTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(PHTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const PHTableDataReducer = PHTableDataSlice.reducer

export const PHExportTableDataAPI = createAsyncThunk("PHExportTableData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_WS_LocationID,
        M_UserID,
        Flag,
        token,
        From,
        To,
        DashProjectTypeId,
        RoleID
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url

    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_Distri_WaterQualityPH_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_Distri_WS_LocationID=${M_WS_LocationID ? M_WS_LocationID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    } else {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_WS_WaterQualityPH_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WS_LocationID=${M_WS_LocationID ? M_WS_LocationID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    }

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const PHExportTableDataSlice = createSlice({
    name: "PHExportTableData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PHExportTableDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(PHExportTableDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(PHExportTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const PHExportTableDataReducer = PHExportTableDataSlice.reducer


export const PHPostDataAPI = createAsyncThunk("PumpingStationPostData", async ({ data }) => {
    const {
        T_WS_WaterQualityPHID,
        T_Distri_WaterQualityPHID,
        PH,
        M_UserID,
        token,
        Flag,
        handleIsPost,
        handleClearField,
        handleOnCloseClick,
        DashProjectTypeId,
        RoleID
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();

    if (DashProjectTypeId == '6' && RoleID != '16') {
        formdata.append("T_Distri_WaterQualityPHID", T_Distri_WaterQualityPHID);
    } else {
        formdata.append("T_WS_WaterQualityPHID", T_WS_WaterQualityPHID);
    }
    formdata.append("PH", PH);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'PATCH',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    let url
    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/Post_WEB_WS_T_Distri_WaterQualityPH_Update`
    } else {
        url = `${BaseUrl}/APKDashboard/Post_WEB_WS_T_WS_WaterQualityPH_Update`
    }

    fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                // handleClearField()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                toastErrorr(result.message)
            }
            return result
        })
})

const PHPostDataSlice = createSlice({
    name: "PHPostData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PHPostDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(PHPostDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(PHPostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const PHPostDataReducer = PHPostDataSlice.reducer

// -----------------Delete API ---------------

export const PHDeleteAPI = createAsyncThunk("PHDelete", async ({ data }) => {
    const {
        T_WS_WaterQualityPHID,
        T_Distri_WaterQualityPHID,
        M_UserID,
        token,
        handleIsPost,
        DashProjectTypeId,
        RoleID
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();

    if (DashProjectTypeId == '6' && RoleID != '16') {
        formdata.append("T_Distri_WaterQualityPHID", T_Distri_WaterQualityPHID);
    } else {
        formdata.append("T_WS_WaterQualityPHID", T_WS_WaterQualityPHID);
    }
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    let url
    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/WEB_WS_T_Distri_WaterQualityPH_Delete`
    } else {
        url = `${BaseUrl}/APKDashboard/WEB_WS_T_WS_WaterQualityPH_Delete`
    }

    fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const PHDeleteSlice = createSlice({
    name: "PHDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PHDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(PHDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(PHDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const PHDeleteReducer = PHDeleteSlice.reducer